import { createSelector } from 'reselect'

export const getPriceTypes = createSelector(
  (state) => state && state.user && state.user.profile && Array.isArray(state.user.profile.priceTypes) &&
    state.user.profile.priceTypes.length ? state.user.profile.priceTypes : null,
  (priceTypes) => priceTypes
)
